export enum ExpertiseTypeEnum {
  All = 0,
  Trade = 1,
  Equipment = 2,
}
